import React, { Component } from 'react';
import { Container, Alert } from 'reactstrap';

class PengkinianDataSucceed extends Component {

    componentDidMount() {
        localStorage.clear();
    }

    render() {
        return (
            <Container>
                <h1>Pengkinan Data Berhasil</h1>
                <p>Pengkinian Data Anda sudah berhasil. Terima kasih.</p>
                <Alert color="success">Kode referensi: {this.props.match.params.ref}</Alert>
            </Container>
        );
    }
}

export default PengkinianDataSucceed;



// WEBPACK FOOTER //
// ./src/components/PengkinianData/PengkinianDataSucceed.js